import { useToast } from "@chakra-ui/react";

export const useTryLaterToast = () => {
  const toast = useToast();

  const tryLater = () => {
    toast({
      title: "Erreur",
      description: "Une erreur est survenue, merci d'essayer plus tard",
      status: "error",
      duration: 5000,
      isClosable: true,
    });
  };

  return { tryLater };
};

export const useSimpleToast = () => {
  const toast = useToast();

  const successToast = (title: string, description: string) => {
    toast({
      title,
      description,
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  const errorToast = (title: string, description: string) => {
    toast({
      title,
      description,
      status: "error",
      duration: 5000,
      isClosable: true,
    });
  };

  const infoToast = (title: string, description: string) => {
    toast({
      title,
      description,
      status: "info",
      duration: 5000,
      isClosable: true,
      colorScheme: 'brand'
    });
  };

  return { success: successToast, error: errorToast, info: infoToast };
};